

















































































































































































































































































import { calculateDayDifference, simpleDate } from "@/lib/utility/date-helper";
import { SharingLinkFactory } from "@/lib/utility/sharingLinkFactory";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import FeatureMixin from "@/mixins/FeatureMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ReportEntity } from "@/models/reportEntity";
import {
  MrfiktivCreateActivityLogDtoGen,
  MrfiktivCreateAttachmentRequestDtoGen,
  MrfiktivCreateSharedContentElementDtoGen,
  MrfiktivDocumentViewModelGen,
  MrfiktivSharedContentViewmodelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { SignDocumentViewModelGen } from "@/services/sign/v1/data-contracts";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ActivityLogModule, ActivityTypeEnum } from "@/store/modules/activity-log.store";
import { AttachmentRequestModule } from "@/store/modules/attachment-request.store";
import { DocumentModule } from "@/store/modules/document.store";
import { PartnerModule } from "@/store/modules/partner";
import { SharedContentModule } from "@/store/modules/shared-content.store";
import { SignRequestModule } from "@/store/modules/sign-request.store";
import { SignModule } from "@/store/modules/sign.store";
import { DigitalSignatureRequestStatusEnum } from "@/views/sign/SignRequestTable.vue";
import debounce from "debounce";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import AEicon from "../utility/AEicon.vue";
import TableWrapper, { ITableWrapperHeader } from "../utility/TableWrapper.vue";

export enum ReportShareSteps {
  DATE = "date",
  IS_EDIT = "isEdit",
  APPENDIXES = "appendixes",
  EDIT_STEPS = "editSteps",
  REQUEST_SUCCESS = "requestSuccess",
  SHARING_SUCCESS = "sharingSuccess"
}

@Component({
  components: { TableWrapper, AEicon }
})
export default class ReportActivityBoxShareComponent extends mixins(
  DarkModeHighlightMixin,
  FeatureMixin,
  PermissionMixin
) {
  @Prop({ default: false })
  hideButton!: boolean;

  @Prop({})
  report!: ReportEntity;

  @Prop({ default: true })
  actionButton!: boolean;

  @Watch("step")
  emitStep() {
    this.$emit("setStep", this.step);
  }

  @Watch("isLoading")
  emitIsLoading() {
    this.$emit("setLoading", this.isLoading);
  }

  selectedAttachments: MrfiktivDocumentViewModelGen[] = [];

  documents: SignDocumentViewModelGen[] = [];

  step = ReportShareSteps.DATE;

  isLoadingDocuments = false;

  readonly STEPS = ReportShareSteps;

  isLoading = false;
  isAttachmentSharingLink = false;

  sharedContent: MrfiktivSharedContentViewmodelGen | null = null;

  get headers(): ITableWrapperHeader[] {
    const headers: ITableWrapperHeader[] = [
      { text: String(this.$t("sign.DocumentTable.type")), align: "start", value: "isTemplate", width: 150 },
      { text: String(this.$t("sign.SignDocumentForm.title")), value: "title" },
      { text: String(this.$t("sign.SignDocumentForm.name")), value: "name" },
      { text: String(this.$t("sign.SignDocumentForm.folder")), value: "folder" },
      {
        text: "",
        value: "timestamp.created",
        type: "date",
        align: "end",
        width: "100px"
      }
    ];

    if (!this.hideButton) {
      headers.push({ text: "", value: "onClick" });
    }

    return headers;
  }

  get minimumExpirationDate() {
    const date = new Date();
    date.setDate(date.getDate() + 1);

    return date.toISOString().substr(0, 10);
  }

  get daysUntilExpirations() {
    return calculateDayDifference(new Date(this.validBy));
  }

  get choices() {
    return [
      {
        icon: "mdi-file-eye-outline",
        title: this.$t("timeLine.ReportActivityBoxShareComponent.shareReadonly"),
        subtitle: this.$t("timeLine.ReportActivityBoxShareComponent.readonlySubtitle"),
        onClick: () => {
          this.step = ReportShareSteps.APPENDIXES;
        }
      },
      {
        icon: "mdi-file-document-edit-outline",
        title: this.$t("timeLine.ReportActivityBoxShareComponent.shareEditable"),
        subtitle: this.$t("timeLine.ReportActivityBoxShareComponent.editableSubtitle"),
        onClick: () => {
          this.step = ReportShareSteps.EDIT_STEPS;
        }
      }
    ];
  }

  get stepActions() {
    switch (this.step) {
      case ReportShareSteps.DATE: {
        return {
          isPrevious: false,
          onPrevious: undefined,
          isNext: true,
          onNext: () => (this.step = ReportShareSteps.IS_EDIT)
        };
      }
      case ReportShareSteps.IS_EDIT: {
        return {
          isPrevious: true,
          onPrevious: () => (this.step = ReportShareSteps.DATE),
          isNext: false,
          onNext: undefined
        };
      }
      case ReportShareSteps.APPENDIXES: {
        return {
          isPrevious: true,
          onPrevious: () => (this.step = ReportShareSteps.IS_EDIT),
          isNext: true,
          onNext: async () => {
            await this.shareReadOnly();
            this.step = ReportShareSteps.SHARING_SUCCESS;
          }
        };
      }
      case ReportShareSteps.EDIT_STEPS: {
        return {
          isPrevious: true,
          onPrevious: () => (this.step = ReportShareSteps.IS_EDIT),
          isNext: true,
          onNext: async () => {
            await this.shareEdit();
            this.step = ReportShareSteps.REQUEST_SUCCESS;
          }
        };
      }
      case ReportShareSteps.SHARING_SUCCESS: {
        return {
          previousLabel: this.$t("timeLine.ReportActivityBoxShareComponent.continue"),
          isPrevious: true,
          onPrevious: this.reset,
          nextLabel: this.$t("timeLine.ReportActivityBoxShareComponent.copy"),
          isNext: true,
          onNext: this.copySharingLinkToClipboard
        };
      }
      case ReportShareSteps.REQUEST_SUCCESS: {
        return {
          previousLabel: this.$t("timeLine.ReportActivityBoxShareComponent.continue"),
          isPrevious: true,
          onPrevious: this.reset,
          nextLabel: this.$t("timeLine.ReportActivityBoxShareComponent.copy"),
          isNext: true,
          onNext: this.copyRequestLinkToClipboard
        };
      }
      default: {
        return {
          previousLabel: "",
          isPrevious: false,
          onPrevious: undefined,
          nextLabel: "",
          isNext: false,
          onNext: undefined
        };
      }
    }
  }

  debounceScrollToBottom = debounce(
    () =>
      document
        .getElementById("PartnerReportDetailInfoTimeLineCardBottomMarkerId")
        ?.scrollIntoView({ behavior: "smooth" }),
    200
  );

  scrollDown() {
    if (this.hideButton) return;

    this.debounceScrollToBottom();
  }

  reset() {
    this.step = ReportShareSteps.DATE;
    this.validBy = this.defaultValidBy;
    this.selectedAttachments.splice(0);
  }

  removeNonSelectableScreens(screens: ReportScreenEnum[]) {
    const unselectableScreens = [
      ReportScreenEnum.closing,
      ReportScreenEnum.closingalt,
      ReportScreenEnum.closingsimple,
      ReportScreenEnum.welcome,
      ReportScreenEnum.welcomealt,
      ReportScreenEnum.REPAREO_HOME,
      ReportScreenEnum.REPAREO_CLOSING
    ];

    return screens.filter(screen => !unselectableScreens.includes(screen));
  }

  screenSelection = this.removeNonSelectableScreens(
    (PartnerModule.partner.settings?.reportSettings.screenOrder ?? []) as ReportScreenEnum[]
  );

  get defaultPartnerUrl() {
    return PartnerModule.partner.settings?.defaultUrl;
  }
  newScreen = ReportScreenEnum.damagedetail;

  addNewScreen() {
    this.screenSelection.push(this.newScreen);
  }

  removeScreen(index: number) {
    this.screenSelection.splice(index, 1);
  }

  moveUp(indexBefore: number) {
    const moved = this.screenSelection.splice(indexBefore, 1)[0];
    const indexAfter = indexBefore - 1;
    this.screenSelection.splice(indexAfter, 0, moved);
  }

  moveDown(indexBefore: number) {
    const moved = this.screenSelection.splice(indexBefore, 1)[0];
    const indexAfter = indexBefore + 1;
    this.screenSelection.splice(indexAfter, 0, moved);
  }

  get screens() {
    return this.removeNonSelectableScreens(
      (PartnerModule.partner.settings?.reportSettings.screenOrder ??
        Object.values(ReportScreenEnum)) as ReportScreenEnum[]
    );
  }

  //default set to 14 days
  readonly defaultValidBy = new Date(Date.now() + 12096e5).toISOString().substring(0, 10);

  validBy = this.defaultValidBy;

  get partnerId() {
    return PartnerModule.partner._id;
  }

  copySharingLinkToClipboard() {
    if (this.sharedContent) {
      const sharingLinkFactory = new SharingLinkFactory(this.sharedContent, false);
      try {
        sharingLinkFactory.copyLinkToClipboard();
        this.$toast.info(this.$t("components.partner.PartnerReportInitializeCard.linkCopied"));
      } catch (error) {
        this.$toast.error(this.$t("components.partner.PartnerReportInitializeCard.error"));
      }
    }
  }

  copyRequestLinkToClipboard() {
    if (this.sharedContent) {
      const sharingLinkFactory = new SharingLinkFactory(this.sharedContent, true);
      try {
        sharingLinkFactory.copyLinkToClipboard();
        this.$toast.info(this.$t("components.partner.PartnerReportInitializeCard.linkCopied"));
      } catch (error) {
        this.$toast.error(this.$t("components.partner.PartnerReportInitializeCard.error"));
      }
    }
  }

  simpleDate(date: string) {
    return simpleDate(date);
  }

  async shareReadOnly() {
    this.isLoading = true;
    this.sharedContent = null;

    try {
      const data: MrfiktivCreateSharedContentElementDtoGen = {
        validBy: new Date(this.validBy).toISOString(),
        refs: [
          {
            refType: BackendResourceEnum.REPORT,
            refId: this.report._id
          }
        ]
      };

      this.selectedAttachments.forEach(selectedAttachment => {
        data.refs.push({
          refId: selectedAttachment.id,
          refType: BackendResourceEnum.DOCUMENT
        });
      });

      this.sharedContent = await SharedContentModule.create({
        partnerId: this.partnerId,
        data
      });
    } catch (error) {
      this.$toast.error("timeLine.ReportActivityBoxShareComponent.failedLinkCreation");
      this.$log.error(error);
    }

    if (this.sharedContent) {
      try {
        const data: MrfiktivCreateActivityLogDtoGen = {
          source: {
            refType: ResourceEnum.REPORT,
            refId: this.report._id
          },
          target: [{ refType: ResourceEnum.SHARED_CONTENT, refId: this.sharedContent.id }],
          actionType: ActionEnum.CREATE,
          activity: ActivityTypeEnum.SHARE
        };
        const activity = await ActivityLogModule.create({ partnerId: this.report.partnerId, data: data });
        ActivityLogModule.addToList(activity);

        this.$emit("save", activity);
      } catch (error) {
        this.$toast.error(this.$t("components.partner.PartnerReportInitializeCard.failedActivityCreation"));
        this.$log.error(error);
      }
    }

    this.isLoading = false;
  }

  async shareEdit() {
    this.isLoading = true;
    this.sharedContent = null;

    try {
      const data: MrfiktivCreateAttachmentRequestDtoGen = {
        validBy: new Date(this.validBy).toISOString(),
        refs: [
          {
            refType: BackendResourceEnum.REPORT,
            refId: this.report._id
          }
        ],
        screenOrder: this.screenSelection
      };

      this.sharedContent = await AttachmentRequestModule.create({
        partnerId: this.partnerId,
        data
      });
    } catch (error) {
      this.$toast.error("timeLine.ReportActivityBoxShareComponent.failedLinkCreation");
      this.$log.error(error);
    }

    if (this.sharedContent) {
      try {
        const data: MrfiktivCreateActivityLogDtoGen = {
          source: {
            refType: ResourceEnum.REPORT,
            refId: this.report._id
          },
          target: [{ refType: ResourceEnum.ATTACHMENT_REQUEST, refId: this.sharedContent.id }],
          actionType: ActionEnum.CREATE,
          activity: ActivityTypeEnum.REQUEST_ATTACHMENT
        };
        const activity = await ActivityLogModule.create({ partnerId: this.report.partnerId, data: data });
        ActivityLogModule.addToList(activity);

        this.$emit("save", activity);
      } catch (error) {
        this.$toast.error(this.$t("components.partner.PartnerReportInitializeCard.failedActivityCreation"));
        this.$log.error(error);
      }
    }

    this.isLoading = false;
  }

  scrollToDocument(documentId: string) {
    const reference = document.getElementById(documentId);
    reference?.scrollIntoView({ behavior: "smooth" });
  }

  setDocument(document?: SignDocumentViewModelGen) {
    if (!document) {
      return;
    }
    const index = this.documents.findIndex(d => d.id === document.id);
    if (index > -1) {
      this.documents.splice(index, 1, document);
    } else {
      this.documents.push(document);
    }
  }

  private async getDocumentForId(documentId?: string) {
    const partnerId = this.partnerId;

    if (!documentId) {
      return;
    }
    const fromList = DocumentModule.maps.id.get(documentId);
    if (fromList) {
      this.setDocument(fromList);
      return;
    }

    const document = await DocumentModule.getOne({
      partnerId,
      documentId
    });

    return document;
  }

  private async getDocumentIdFromSignId(requestId: string) {
    const partnerId = this.partnerId;

    const signRequest = await SignRequestModule.getOne({
      partnerId,
      requestId
    });

    if (signRequest.status !== DigitalSignatureRequestStatusEnum.SIGNED) {
      if (!signRequest.documents.length) {
        return;
      }

      return signRequest.documents[0];
    }

    const signatures = await SignModule.findAll({ partnerId, requestId });

    if (signatures.length) {
      const signId = signatures[0].id;
      const signature = await SignModule.findOne({ partnerId, requestId, signId });
      if (!signature.documents?.length) {
        return;
      }

      return signature.documents[0].id;
    }
  }

  @Watch("step")
  async loadDocuments() {
    if (this.step !== ReportShareSteps.IS_EDIT) return;

    this.isLoadingDocuments = true;

    const setDocumentsAsync: Promise<void>[] = [];
    for (const log of ActivityLogModule.paginationList) {
      if (!log?.target?.length) {
        continue;
      }

      const refId = log?.target[0].refId;
      if (!refId) {
        continue;
      }

      switch (log.activity) {
        case ActivityTypeEnum.CREATE_DOCUMENT: {
          const documentId = refId;
          const promise = this.getDocumentForId(documentId)
            .then(this.setDocument)
            .catch(this.$log.error);

          setDocumentsAsync.push(promise);
          break;
        }
        case ActivityTypeEnum.REQUEST_SIGNATURE: {
          const signId = refId;
          const promise = this.getDocumentIdFromSignId(signId)
            .then(this.getDocumentForId)
            .then(this.setDocument)
            .catch(this.$log.error);

          setDocumentsAsync.push(promise);
          break;
        }
      }
    }

    await Promise.all(setDocumentsAsync);
    this.isLoadingDocuments = false;
  }
}
